"use client";

import { ContactForm } from "@/components/ContactForm";
import { useLang } from "@/components/LangProvider";

export function ContactView() {
  const { t } = useLang();
  const c = t.contactPage;

  return (
    <div className="bg-background text-foreground">
      {/* Page hero — light paper bg */}
      <section className="relative bg-paper text-foreground overflow-hidden">
        <div className="mx-auto max-w-site px-6 md:px-14 pt-32 md:pt-40 pb-24 md:pb-28 text-center">
          <p
            className="text-mute font-medium uppercase font-sans mb-3 inline-block"
            style={{ fontSize: 11, letterSpacing: "0.3em" }}
          >
            {c.label}
          </p>
          <h1
            className="font-display text-deep max-w-[16ch] mx-auto"
            style={{
              fontWeight: 500,
              fontSize: "clamp(34px, 5vw, 64px)",
              lineHeight: 1.25,
              letterSpacing: "0.04em",
              margin: "14px auto 18px",
              textWrap: "balance",
            }}
          >
            {c.title}
          </h1>
          <p
            className="text-[#4a4a4a] font-sans max-w-[600px] mx-auto whitespace-pre-line"
            style={{ fontSize: 15, lineHeight: 2, marginTop: 18 }}
          >
            {c.lede}
          </p>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="mx-auto max-w-3xl px-6 md:px-14">
          <div className="grid gap-10 md:grid-cols-[5fr_7fr] md:gap-20 md:items-start">
            <div>
              <p className="text-[11px] uppercase tracking-[0.3em] text-mute font-medium font-sans mb-3.5">
                {c.inquiryLabel}
              </p>
              <h2
                className="font-display text-deep m-0"
                style={{
                  fontWeight: 500,
                  fontSize: "clamp(20px, 2.4vw, 28px)",
                  lineHeight: 1.45,
                  letterSpacing: "0.04em",
                }}
              >
                {c.inquiryHeading}
              </h2>
            </div>
            <ul className="border-t border-rule list-none p-0 m-0">
              {c.inquiryTypes.map((it) => (
                <li
                  key={it}
                  className="flex items-baseline gap-3 py-3.5 border-b border-rule font-display text-[#4a4a4a]"
                  style={{ fontSize: 15, letterSpacing: "0.04em" }}
                >
                  <span className="text-mute font-mono" style={{ fontSize: 10, letterSpacing: "0.18em" }}>
                    —
                  </span>
                  <span>{it}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* フォーム。以前は mailto リンクしか無く、問い合わせを取りこぼしていた */}
          <div className="mt-20 md:mt-28">
            <p className="text-[11px] uppercase tracking-[0.3em] text-mute font-medium font-sans mb-3.5">
              {c.form.label}
            </p>
            <h2
              className="font-display text-deep mt-0 mb-10"
              style={{
                fontWeight: 500,
                fontSize: "clamp(20px, 2.4vw, 28px)",
                lineHeight: 1.45,
                letterSpacing: "0.04em",
              }}
            >
              {c.form.heading}
            </h2>
            <ContactForm />
          </div>

          <div className="mt-20 md:mt-28 text-center">
            <p
              className="text-mute font-medium uppercase font-sans mb-6"
              style={{ fontSize: 10.5, letterSpacing: "0.3em" }}
            >
              {c.otherLabel}
            </p>
            <div className="flex flex-wrap justify-center gap-3">
              <a
                href="https://shop.plum-town.jp/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-5 py-3 font-medium font-sans uppercase text-[#4a4a4a] border border-rule hover:text-accent-forest hover:border-accent-forest transition-colors"
                style={{ fontSize: 11, letterSpacing: "0.22em" }}
              >
                <span>{c.otherShop}</span>
              </a>
              <a
                href="https://note.com/plumtown"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-5 py-3 font-medium font-sans uppercase text-[#4a4a4a] border border-rule hover:text-accent-forest hover:border-accent-forest transition-colors"
                style={{ fontSize: 11, letterSpacing: "0.22em" }}
              >
                <span>{c.otherNote}</span>
              </a>
              <a
                href="https://www.instagram.com/soga_craft_umeshu/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-5 py-3 font-medium font-sans uppercase text-[#4a4a4a] border border-rule hover:text-accent-forest hover:border-accent-forest transition-colors"
                style={{ fontSize: 11, letterSpacing: "0.22em" }}
              >
                <span>{c.otherInstagram}</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
